export default __webpack_public_path__ + "static/media/ISMO CLASS-5 EXAM PATTERN 2025.739f666a.pdf";